import React from 'react';
import { useLocation } from 'react-router';
import { Menu as UikitMenu } from '@pancakeswap/uikit';
import { languageList } from 'config/localization/languages';
import { useTranslation } from 'contexts/Localization';
import PhishingWarningBanner from 'components/PhishingWarningBanner';
import useTheme from 'hooks/useTheme';
import { usePriceCakeBusd } from 'state/farms/hooks';
import { usePhishingBannerManager } from 'state/user/hooks';
import config from './config/config';
import UserMenu from './UserMenu';
import GlobalSettings from './GlobalSettings';
import { getActiveMenuItem, getActiveSubMenuItem } from './utils';
import { footerLinks } from './config/footerConfig';

const Menu = (props) => {
  const { isDark, toggleTheme } = useTheme();
  const cakePriceUsd = usePriceCakeBusd();
  const { currentLanguage, setLanguage, t } = useTranslation();
  const { pathname = '/' } = useLocation(); // Fallback to '/'
  const [showPhishingWarningBanner] = usePhishingBannerManager();

  console.log('Menu pathname:', pathname); // Debug

  const activeMenuItem = getActiveMenuItem({ menuConfig: config(t), pathname }); // Line 23
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname }); // Line 24

  return (
    <UikitMenu
      userMenu={<UserMenu />}
      globalMenu={<GlobalSettings />}
      banner={showPhishingWarningBanner && <PhishingWarningBanner />}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={currentLanguage.code}
      langs={languageList}
      setLang={setLanguage}
      cakePriceUsd={cakePriceUsd.toNumber()}
      links={config(t)}
      subLinks={activeMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
      footerLinks={footerLinks(t)}
      activeItem={activeMenuItem?.href}
      activeSubItem={activeSubMenuItem?.href}
      buyCakeLabel={t('Buy MONEY')}
      {...props}
    />
  );
};

export default Menu;